import React from 'react';

import { ToastContainer, cssTransition, toast as toastify } from 'react-toastify';
import styled from 'styled-components';

import { ReactToastifyContainer } from 'components/toast/toast-container.styled';
import { ToastView } from 'components/toast/toast.view';
import { IToastOptions } from 'components/toast/types';

export const IncentiveToastContainer = styled(ReactToastifyContainer)`
  .Toastify__toast-container {
    inset-inline-start: 0;
  }
`;

export const IncentiveDetailsToast = () => {
  return (
    <IncentiveToastContainer>
      <ToastContainer
        containerId="incentive-detail"
        closeButton={false}
        transition={cssTransition({
          enter: 'zoomIn',
          exit: 'zoomOut',
          duration: 250,
        })}
        position="bottom-center"
        limit={3}
        hideProgressBar={false}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </IncentiveToastContainer>
  );
};

export const incentiveToast = (message: string, { closeIcon }: IToastOptions = {}) =>
  toastify(
    props => <ToastView type="success" message={message} closeIcon={closeIcon} {...props} />,
    {
      type: 'success',
      autoClose: 3.5 * 1000,
      containerId: 'incentive-detail',
    }
  );
